export default __webpack_public_path__ + "static/media/games-hover.c53df6e1.webp";